module.exports = __webpack_public_path__ + "media/images/athletes/2207-e7f30bdb9c201b60fe5c93a7b0bef84a.png";